module.exports = __webpack_public_path__ + "static/media/Venusaur_gaussian2.c703d39c.png";